<template>
    <div class="pt-2 pb-6">
        <div class="flex gap-4">
            <div>
                <div class="text-sm">Bilagstype</div>

                <USelect
                    v-model="selectedConfigKey"
                    class="min-w-[240px]"
                    :items="fieldConfigPresets"
                />
            </div>
            <div>
                <div class="text-sm">
                    Feltoppsett
                </div>
                <UButton
                    color="neutral"
                    variant="outline"
                    class="px-2 h-fit flex justify-between items-center gap-1"
                    @click="showConfig = !showConfig"
                >
                    <i class="block i-ph-pencil"/>
                    Endre
                </UButton>

                <UCard v-if="showConfig" class="mt-2 flex flex-col">
                    <div class="flex justify-between items-start">
                        <div>
                            <div>Feltoppsett</div>
                            <div class="text-sm italic mb-4">Dra felt for å omorganisere</div>
                        </div>
                        <UButton
                            variant="ghost"
                            color="neutral"
                            class="h-fit"
                            @click="showConfig = false"
                        >
                            <i class="block i-ph-x"/>
                        </UButton>
                    </div>


                    <div class="flex gap-12 flex-wrap text-sm">
                        <div class="flex-1">
                            <div class="border-b border-base-300">Primærlinje</div>
                            <draggable
                                v-model="primaryFieldsModel"
                                class="list-group h-full"
                                group="fields"
                                item-key="key"
                            >
                                <template #item="{element}">
                                    <li class="list-group-item flex items-center gap-2" @click="element.fixed = !element.fixed">
                                        <div class="handle block cursor-grab debug i-ph-dots-nine"/>

                                        <span>{{ element.label }}</span>

                                        <div class="grow"/>
                                    </li>
                                </template>
                            </draggable>
                        </div>

                        <div class="flex-1">
                            <div class="border-b border-base-300">Utvidet visning</div>
                            <draggable
                                v-model="expandedFieldsModel"
                                class="list-group g-full"
                                group="fields"
                                item-key="key"
                            >
                                <template #item="{element}">
                                    <li class="list-group-item flex items-center gap-2" @click="element.fixed = !element.fixed">
                                        <div class="handle block cursor-grab debug i-ph-dots-nine"/>
                                        <span>{{ element.label }}</span>
                                        <div class="grow"/>
                                    </li>
                                </template>
                            </draggable>
                        </div>

                        <div class="flex-1">
                            <div class="border-b border-base-300">Skjulte felt</div>
                            <draggable
                                v-model="hiddenFieldsModel"
                                class="list-group h-full"
                                group="fields"
                                item-key="key"
                            >
                                <template #item="{element}">
                                    <li class="list-group-item flex items-center gap-2" @click="element.fixed = !element.fixed">
                                        <div class="handle block cursor-grab debug i-ph-dots-nine"/>
                                        <span>{{ element.label }}</span>
                                        <div class="grow"/>
                                    </li>
                                </template>
                            </draggable>
                        </div>
                    </div>
                </UCard>
            </div>
            <div>
                <div class="text-sm">Lim inn bilagslinjer</div>
                <UInput
                    placeholder="Bilagslinjer fra regneark"
                    @paste="onPaste"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import useDynamicTransactionFields from './transaction-fields.controller'
import draggable from 'vuedraggable'
import {computed, ref} from 'vue'
import {usePasteHandler} from '@/csv-transaction-importer/createTransPasteHandler'

const onPaste = usePasteHandler()

const {selectedConfigKey, transactionFieldConfig, primaryFields, fieldConfigPresets, expandedFields, hiddenFields} = useDynamicTransactionFields()

const primaryFieldsModel = computed({
    get: () => primaryFields.value,
    set: (value) => {
        transactionFieldConfig.value[selectedConfigKey.value].primary = value.map(field => field.key)
    }
})

const expandedFieldsModel = computed({
    get: () => expandedFields.value,
    set: (value) => {
        transactionFieldConfig.value[selectedConfigKey.value].expanded = value.map(field => field.key)
    }
})

const hiddenFieldsModel = computed({
    get: () => hiddenFields.value,
    set: (value) => {
        transactionFieldConfig.value[selectedConfigKey.value].hidden = value.map(field => field.key)
    }
})

const showConfig = ref(false)

</script>